import React, { useState, useEffect } from 'react'
import { ChartTitle } from '../Components'
import { Flex } from '../../../../Components'
import { formatPrice } from '../../../../Charts/Functions'
import { Chart } from './Chart'

export function SavingsPerMotivazione1 ({ dbData = [] }) {
  const [tableData, setTableData] = useState([])

  const [year1 = ''] = dbData?.map(({ Anno }) => Anno)?.filter((value, index) => dbData.map(({ Anno }) => Anno)?.indexOf(value) === index).sort().reverse()

  useEffect(() => {
    const elements = []

    dbData.forEach(({ Motivazione1, QuantitaBiglietti, SommaTotaleBiglietto, SommaTariffaMinima, SommaTariffaUfficiale, Saving, MissSaving }) => {
      elements.push({
        Motivazione1,
        QuantitaBiglietti,
        SommaTotaleBiglietto,
        SommaTariffaMinima,
        SommaTariffaUfficiale,
        Saving,
        MissSaving
      })
    })
    elements.push({
      Motivazione1: 'Totale',
      QuantitaBiglietti: dbData.reduce((acc, { QuantitaBiglietti }) => acc + parseFloat(QuantitaBiglietti), 0),
      SommaTotaleBiglietto: dbData.reduce((acc, { SommaTotaleBiglietto }) => acc + parseFloat(SommaTotaleBiglietto), 0),
      SommaTariffaMinima: dbData.reduce((acc, { SommaTariffaMinima }) => acc + parseFloat(SommaTariffaMinima), 0),
      SommaTariffaUfficiale: dbData.reduce((acc, { SommaTariffaUfficiale }) => acc + parseFloat(SommaTariffaUfficiale), 0),
      Saving: dbData.reduce((acc, { Saving }) => acc + parseFloat(Saving), 0),
      MissSaving: dbData.reduce((acc, { MissSaving }) => acc + parseFloat(MissSaving), 0)
    })
    setTableData(elements)
  }, [dbData])

  if (tableData.length > 15) {
    return (
      <>
        <div style={{ width: '100vw', height: '100vh' }}>
          <Flex fh fw>
            <ChartTitle title={`Saving Per Motivazione ${year1}`} />
            <Table tableData={tableData} />
          </Flex>
        </div>
        <div style={{ width: '100vw', height: '100vh' }}>
          <Flex fh fw>
            <ChartTitle title={`Saving Per Motivazione ${year1}`} />
            <Chart data={dbData} />
          </Flex>
        </div>
      </>
    )
  }
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <Flex fh fw>
        <ChartTitle title={`Saving Per Motivazione ${year1}`} />
        <Table tableData={tableData} />
        <Chart data={dbData} />
      </Flex>
    </div>
  )
}

const Table = ({ tableData }) => {
  return (
    <table className='tableChart'>
      <thead>
        <tr style={{ fontWeight: 'bold' }}>
          <th>Motivazione</th>
          <th>Quantità Biglietti</th>
          <th>Tariffa Applicata</th>
          <th>Tariffa Pubblica</th>
          <th>Tariffa Minima</th>
          <th>Saving</th>
          <th>MissSaving</th>
        </tr>
      </thead>
      <tbody>
        {tableData.map(({ Motivazione1, QuantitaBiglietti, SommaTotaleBiglietto, SommaTariffaMinima, SommaTariffaUfficiale, Saving, MissSaving, SommaTotaleBiglietto2, SommaTariffaMinima2, SommaTariffaUfficiale2, Saving2, MissSaving2 }, key) =>
          <tr key={key} style={{ fontWeight: Motivazione1 === 'Totale' ? 'bold' : 'normal' }}>
            <td>{Motivazione1}</td>
            <td>{QuantitaBiglietti}</td>
            <td style={{ backgroundColor: '#80a6dc72', color: 'rgb(5, 15, 102)' }}>{formatPrice(SommaTotaleBiglietto)}</td>
            <td>{formatPrice(SommaTariffaUfficiale)}</td>
            <td>{formatPrice(SommaTariffaMinima)}</td>
            <td>{formatPrice(Saving)}</td>
            <td>{formatPrice(MissSaving)}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}
